import { EnumSchema, Executor, FromSchema, ZodDate } from '@40seas/entities/common';
import { BaseEntity, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { CreditSafePortfolioEventStatus } from './credit-safe-portfolio.event.status';

export const CreditSafePortfolioEventSchema = WithBaseEntitySchema(
    z.object({
        portfolioId: z.string(),
        status: EnumSchema(CreditSafePortfolioEventStatus),
        ruleCode: z.number(),
        eventId: z.number(),
        connectionId: z.string(),
        newValue: z.any(),
        oldValue: z.any(),
        eventDate: ZodDate,
        buyer: z.string(),
    }),
).strict();

export class CreditSafePortfolioEvent extends FromSchema(CreditSafePortfolioEventSchema) implements BaseEntity {
    id: string;
    portfolioId: string;
    status: CreditSafePortfolioEventStatus;
    ruleCode: number;
    eventId: number;
    connectionId: string;
    newValue: any;
    oldValue: any;
    eventDate: Date;
    createdAt: Date;
    updatedAt: Date;
    buyer: string;
    tenantId: string;
    createdBy?: Executor;
    seller?: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
